module.exports = __webpack_public_path__ + "static/img/ECOP_banner@2x.6b000fe2.png";